import toast from "react-hot-toast";
import usePut from "../put/usePut";

const useSetDefaultCompany = () => {
  const { handleAuth: setDefaultCompany } = usePut({
    url: "user/set_default_company",
    passCompanyId: false,
    refreshUrl: ["user-companies-list-infinite"],
    onSuccess: (res) => {
      toast.success(res?.data?.message || "Default company updated successfully");
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message || "Something went wrong"
      );
    },
  });

  const handleSetDefaultCompany = (company_id) => {

    setDefaultCompany.mutate({ company_id });
  };

  return {
    ...setDefaultCompany,
    handleSetDefaultCompany,
    isSettingDefault: setDefaultCompany.isLoading,
    isLoading: setDefaultCompany.isLoading,
    targetCompanyId: setDefaultCompany.variables?.company_id,
  };
};

export default useSetDefaultCompany;
